import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {StatusPage} from "../StatusPage";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {DateTime} from "../../components/ListComponent/DateTime";
import {Util} from "../../components/Util";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";
import {Dictionary} from "../../components/Dictionary";

export class ProductHistory extends ListComponent {
    protected limit: number = 250;

    protected getRequestUrl(): RequestInfo | URL {
        return '/product/history';
    }

    render() {
        if (this.state?.code && this.state?.message) {
            return <StatusPage code={this.state.code} message={this.state.message}/>;
        }

        const params: {} | any = this.getFormData(), dictionary: Dictionary = this.dictionary;

        return (
            <>
                <div className="row">
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className="row">
                            <h5>{this.dictionary.get['search']}</h5>

                            <div className="col-md-12 sub-details">
                                <div className="row">
                                    {/*<div className="col-lg-12 col-xl-6">*/}
                                    {/*    <FormGroup.Input {...{id: 'search', defaultValue: params?.search}}/>*/}
                                    {/*</div>*/}
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Select {...{
                                            id: 'event',
                                            basic: 'show-all',
                                            items: ['b2c-order', 'b2b-order', 'receipt', 'shipment', 'transfer-product'],
                                            defaultValue: this.state?.item?.status || 'active'
                                        }}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Input {...{id: 'product_id', defaultValue: params?.product_id}}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Input {...{id: 'sku', defaultValue: params?.sku}}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.DateTime {...{
                                            id: 'created_from',
                                            defaultValue: params?.created_from
                                        }}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.DateTime {...{
                                            id: 'created_to',
                                            defaultValue: params?.created_to
                                        }}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'x.created_at:d'}/>
                        {this.listOfSearchParams(params)}
                        <div className="row">
                            <div className="col-12 caption">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <button className="btn btn-sm btn-light"
                                        onClick={((event: MouseEvent | any) => {
                                            event.preventDefault();
                                            this.exportTableData('/product/historyExport')
                                        })}>
                                    {this.dictionary.get['export']}
                                </button>
                                &nbsp;
                                &nbsp;
                                <h6>
                                    {this.dictionary.get['product-history']}: &nbsp;
                                    <strong>{this.state.count ? <FormattedNumber
                                        value={this.state.count}/> : '-'}</strong> {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                        <div className="row" style={{marginBottom: '10px'}}>
                            <div className="col-md-4">
                                {this.dictionary.get['quantity']}:&nbsp;
                                <strong>
                                    {this.state?.item?.quantity ?
                                        <FormattedNumber value={this.state.item.quantity}/> : '-'}
                                </strong>
                                &nbsp;{this.dictionary.get['pc']}
                            </div>
                            <div className="col-md-4">
                                {this.dictionary.get['isolated_quantity']}:&nbsp;
                                <strong>
                                    {this.state?.item?.isolated_quantity ?
                                        <FormattedNumber value={this.state.item.isolated_quantity}/> : '-'}
                                </strong>
                                &nbsp;{this.dictionary.get['pc']}
                            </div>
                            <div className="col-md-4">
                                SUM:&nbsp;
                                <strong>
                                    {this.state?.item?.sum ? <FormattedNumber value={this.state.item.sum}/> : '-'}
                                </strong>
                                &nbsp;{this.dictionary.get['pc']}
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="x.created_at">
                                    # <i className="bi bi-sort-down-alt"></i>
                                </th>
                                <th>{this.dictionary.get['event']}</th>
                                <th>{this.dictionary.get['event']} ID</th>
                                <th>{this.dictionary.get['product_name']}</th>
                                <th>{this.dictionary.get['product_id']}</th>
                                <th>{this.dictionary.get['sku']}</th>
                                <th>{this.dictionary.get['quantity']}</th>
                                <th>{this.dictionary.get['isolated_quantity']}</th>
                                <th className="sortable" data-sortkey="x.created_at">
                                    {this.dictionary.get['created']}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                const productLink: string = '/product/details/' + elem.product_id;
                                if (elem.event_type === 'transfer') {
                                    elem.event_type = 'transfer-product'
                                }
                                let event_uri: string = elem.event_type;
                                if (elem.event_type === 'b2c-order' || elem.event_type === 'b2b-order') {
                                    event_uri = 'order'
                                }
                                const eventLink: string = '/' + event_uri + '/details/' + elem.event_id;
                                return (
                                    <tr key={elem.item_id} data-id={elem.item_id}>
                                        {Util.copyCell(elem.item_id, {style: {textAlign: 'right'}})}
                                        <td>{dictionary.get[elem.event_type]}</td>
                                        <td>{Util.link(elem.event_id, eventLink)}</td>
                                        <td>{elem.name}</td>
                                        <td>{Util.link(elem.product_id, productLink)}</td>
                                        {Util.searchCell(elem.sku, 'sku')}
                                        <td>{parseInt(elem.quantity)}</td>
                                        <td>{parseInt(elem.isolated_quantity)}</td>
                                        <td><DateTime value={elem.created_at} inline={true}/></td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={8}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        );
    }
}
